// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"59c6d73b","275":"65e3c7fe","664":"97462cd9","930":"f7005172"}[chunkId] + ".chunk.css";
};